import { PdpTypeEnum } from '../enums';

export function getPdpType(urlParam: string): PdpTypeEnum {
  switch (urlParam) {
    case 'faq':
      return PdpTypeEnum.FAQ;
    case 'instructions-for-use':
      return PdpTypeEnum.IFU;
    case 'accessory':
      return PdpTypeEnum.ACCESSORY;
    default:
      return PdpTypeEnum.PRODUCT;
  }
}
